import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => ({
  partiallyHidden: {
      color: theme.palette.primary.main,
  },
}));
